export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.83 11 5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\"/>"
};